import React from "react";
import { styled } from "@mui/system";
import { MuiTelInput } from "mui-tel-input";
export const CustomTelInput = ({number , onNumberChanged}:{number :string , onNumberChanged : Function}) => {
  return (
    <MuiTelInputStyled
      size="small"
      variant="standard"
      style={{
        border: "0px",
        backgroundColor: "#eeedf3",
        borderRadius: "5px",
      }}
      value={number}
      onChange={(n) => onNumberChanged( n)}
      defaultCountry="DZ"
    />
  );
};

const MuiTelInputStyled = styled(MuiTelInput)`
  padding-left: 10px;

  & input {
    font-family: "Plus Jakarta Sans";
    height: 40px;
  }
  & div::before {
    border-bottom: 0px solid #eee;
  }
`;
